import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=13a69168&scoped=true&"
import script from "./prize.js?vue&type=script&lang=js&"
export * from "./prize.js?vue&type=script&lang=js&"
import style0 from "./Prize.vue?vue&type=style&index=0&id=13a69168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a69168",
  null
  
)

export default component.exports